// Central editable content for Present You Perfect
// Update these values to change what appears on the site.

export const SITE = {
  brand: "Present You Perfect",

  founder: {
    name: "Marie Thelusma-Chase, CFRE",
    title: "Founder of Present You Perfect",
    initials: "MTC",
    // Replace with your professional photo URL (upload to any image host or object storage)
    // Leave empty ("") to show the elegant initials placeholder.
    photoUrl:
      "https://customer-assets.emergentagent.com/job_grant-drafter/artifacts/ybpfq31x_headshoot.png",
    bio: [
      "Present You Perfect was created to help bring the vision inside of you into reality. My goal is to draw out your dreams, shape them into clear words, and help others see the purpose, power, and possibility behind your idea.",
      "I have been working in grant writing, fundraising, and nonprofit development since 2002 and have served as a Certified Fund Raising Executive for the past 10 years. Through Present You Perfect, I support nonprofit leaders, entrepreneurs, visionaries, and changemakers with proposals, letters of inquiry, sponsorship requests, program summaries, and practical next steps that help move ideas forward.",
      "Your vision deserves to be seen. Let's bring it to life together.",
    ],
    email: "presentyouperfect@gmail.com",
    linkedin:
      "https://www.linkedin.com/in/marie-thelusma-chase-cfre-bab3712b7/",
    ctaPrimaryLabel: "Start Building My Vision",
    ctaSecondaryLabel: "Connect with Marie on LinkedIn",
    sectionEyebrow: "Meet the Founder",
    sectionHeadline: "Meet Marie Thelusma-Chase, CFRE",
  },

  coaching: {
    sectionEyebrow: "Group Coaching",
    sectionHeadline: "Thursdays with Marie Thelusma-Chase, CFRE",
    subheadline:
      "Virtual group coaching for nonprofit leaders, entrepreneurs, visionaries, and changemakers who need support turning their ideas into clear, fundable language.",
    intro:
      "You do not have to figure out grant writing alone. Thursdays with Marie Thelusma-Chase, CFRE is a group coaching space designed to help you strengthen your grant application, clarify your funding request, improve your proposal language, and take the next step with confidence.",
    julyFocus: {
      title: "July Focus: Find Your Funding Lane\u2122",
      body: [
        "Do you have a nonprofit idea, ministry project, community program, or vision for helping people \u2014 but you're not sure how to explain it in grant language?",
        "Join this 60-minute session and learn how to begin turning your vision into clear, fundable language.",
      ],
    },
    whoFor: {
      title: "Who this is for",
      lead: "This session is ideal for people who are:",
      items: [
        "Working on small grant applications",
        "Starting a nonprofit, ministry project, or community program",
        "Trying to explain a new idea or program in grant language",
        "Unsure what funders are asking for",
        "Looking for practical guidance on how to get started",
      ],
    },
    leaveWith: {
      title: "What you will leave with",
      body:
        "You will leave with a clearer funding lane, stronger language for your idea, and next steps for building your proposal, letter of inquiry, sponsorship request, or funding document.",
    },
    aboutMarie: {
      title: "About Marie",
      body:
        "Marie has been working in grant writing and nonprofit development since 2002 and has served as a Certified Fund Raising Executive for the past 10 years. Participants can bring their ideas, drafts, grant opportunities, questions, or unfinished applications and receive practical guidance on how to move forward.",
    },
    julyDates: {
      title: "July session dates",
      lead: "July virtual sessions meet on Thursdays at 6:00 PM:",
      items: [
        "Thursday, July 16 at 6:00 PM",
        "Thursday, July 30 at 6:00 PM",
      ],
    },
    summerSpecial: {
      title: "Summer special",
      regularRate: "Regular session rate: $97.00",
      julyRate: "July Summer Rate: $47.00",
      note:
        "For July only, you can attend Find Your Funding Lane\u2122 at the special summer rate of $47.00 per session. Registration is required. Space may be limited.",
    },
    afterSession: {
      title: "After the session",
      body: [
        "After attending one session, you are invited to schedule a complimentary 30-minute Funding Strategy Session.",
        "There is absolutely no obligation. This session is simply a chance to discuss your draft, identify your next best step, and explore what kind of support may fit your time, budget, deadline, and funding goals.",
        "You can also start your draft anytime at PresentYouPerfect.com. No account is required to begin. Create an account only if you want to save your work and return later.",
      ],
    },
    ctaLabel: "Register for Thursdays with Marie",
    ctaLink: "https://tidycal.com/presentyouperfect/findyourlane",
  },

  resultsCallout: {
    title: "Need help strengthening your grant application?",
    body:
      "Your draft is a strong start. Bring it to Thursdays with Marie Thelusma-Chase, CFRE and get support turning it into a grant application you feel confident submitting.",
    ctaLabel: "Register for Thursday Group Coaching",
    ctaLink: "https://tidycal.com/presentyouperfect/findyourlane",
  },

  testimonial: {
    eyebrow: "What Participants Are Saying",
    quote:
      "This class fundamentally changed how I approach grant writing. Mrs. Thelusma\u2019s passion is absolutely contagious! She didn\u2019t just teach the mechanics of asking for support; she provided deeply practical tools and helped me connect my heart to the mission. I left feeling incredibly empowered, supported, and ready to make a real difference.",
    attribution: "Elizabeth H., Port St. Lucie, FL",
    impact:
      "By the time Elizabeth completed the session, she had a complete master proposal, a list of funders who fund this type of project in her area code, and clear next steps.",
  },

  book: {
    title: "Chasing After Impact",
    subtitle:
      "Remembering What Truly Matters When Seeking to Transform Lives",
    author: "Marie Thelusma-Chase, CFRE",
    homepageFeature: {
      header: "Check Out the Book",
      body:
        "Chasing After Impact is a companion book for visionaries, nonprofit leaders, ministry leaders, and community builders who want to remember the impact behind the work.",
      ctaLabel: "Check Out the Book",
    },
    // Paste your book cover URL here (recommend a tall JPG/PNG, 3:4 aspect ratio)
    coverUrl:
      "https://customer-assets.emergentagent.com/job_grant-drafter/artifacts/ixyotm6v_book_cover_chasing_after_impact.png",
    amazonLink:
      "https://www.amazon.com/Chasing-after-Impact-Remembering-Transform/dp/B0CK9YP5B6/ref=sr_1_1?crid=OI0RLXIL2YCV&dib=eyJ2IjoiMSJ9.EvYm59Q_gF6snNuF02H98A.lFx8nXWmGEg2MXej_BhESgvFvM5u9rPYdis267upoZo&dib_tag=se&keywords=chasing+after+impact+marie+thelusma+chase&qid=1783120607&sprefix=chasing+after+impact+marie+thelusma+chase%2Caps%2C142&sr=8-1",
    heroBody: [
      "Chasing After Impact is a companion book for visionaries, nonprofit leaders, ministry leaders, and community builders who are ready to remember the impact behind the work.",
      "Before you chase funding, you need to remember the people, purpose, and transformation behind your vision. This book connects with the heart of Present You Perfect because strong grant writing begins with clarity about who you serve, why the work matters, and what change you hope to create.",
    ],
    caseStudy: {
      sectionTitle: "Case Study from the Book",
      headline:
        "From Grant Writing to Impact: The Elizabethport Presbyterian Center Story",
      body: [
        "This was the place where Marie began to understand that grant writing should be about more than creating winning applications. In 2002, she was hired to raise a minimum of $200,000 annually in new funding streams while also helping sustain existing programs. At the time, the organization had an annual budget of approximately $2 million and was already a trusted beacon in the community.",
        "The grants did not create the organization\u2019s impact from scratch; they helped deepen and expand its engagement with teen and senior populations.",
        "Grants should always be connected to outcomes, transformation, and the lasting impact an organization hopes to create.",
        "This story reflects the heart of Present You Perfect: helping you move beyond simply asking for money and begin clearly explaining who you serve, what problem you are addressing, and what meaningful change your work can make.",
      ],
      pullQuote:
        "This is where the shift began: from chasing grants to chasing impact.",
      previewLabel: "Preview from Chapter 1",
      previewCaption: "From Chapter 1: Why Impact is Important",
      // Paste your case-study page image URL here (a scan/screenshot of page 10)
      previewImageUrl:
        "https://customer-assets.emergentagent.com/job_grant-drafter/artifacts/mwnne2ex_elizabethport_case_study_page-10_under2000.png",
    },
    bottomCta: {
      heading: "Ready to start putting your impact into words?",
      startDraftLabel: "Start Your Draft",
      registerLabel: "Register for Find Your Funding Lane\u2122",
    },
  },
};
